<template>
  <el-dialog :title="dialogTitle"
             :visible.sync="visible"
             width="90%"
             :before-close="handleClose"
             :close-on-click-modal="false"
             append-to-body>

    <!-- 加载状态 -->
    <div v-if="loading"
         class="loading-container">
      <el-loading text="加载中..." />
    </div>

    <!-- 表格 -->
    <el-table v-else
              :data="tableData"
              border
              style="width: 100%"
              height="500">

      <el-table-column label="省份"
                       prop="province_name"
                       min-width="120"
                       align="center">
      </el-table-column>

      <el-table-column label="院校名称"
                       prop="college_name"
                       min-width="180"
                       align="center">
      </el-table-column>

      <el-table-column label="专业名称"
                       min-width="180"
                       align="center">
        <template slot-scope="scope">
          {{ `${scope.row.major_name}(${scope.row.major_code})` }}
        </template>
      </el-table-column>

      <el-table-column label="院校类型"
                       min-width="150"
                       align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.college_category_level">
            {{ getCategoryLabel(scope.row.college_category_level) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="院校调剂人数"
                       min-width="120"
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.cm_user_count_all_pre || 0 }}人
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="100"
                       align="center"
                       fixed="right">
        <template slot-scope="scope">
          <el-link type="primary"
                   :underline="false"
                   @click="handleDetail(scope.row)">
            详情
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container"
         v-if="total > 0">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 30, 50]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>

    <!-- 空数据提示 -->
    <!-- <div v-if="!loading && total === 0"
         class="empty-data">
      暂无数据
    </div> -->

  </el-dialog>
</template>

<script>
import { getMoreData, getProvincelist } from '@/api/adjust.js'

export default {
  name: 'MoreDataDialog',
  props: {
    // 从父组件传入的查询参数
    queryParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      dialogTitle: '',
      categoryType: '',
      categoryValue: null, // 类别对应的值（0,1,2,3）
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      categoryMap: {
        0: '保底院校',
        1: '重点推荐院校',
        2: '备选院校',
        3: '冲刺院校',
      },
      adjustreportid: '',
      provincelist: '',
    }
  },

  methods: {
    fetchProvincelist() {
      getProvincelist().then((res) => {
        this.provincelist = res.list
        this.fetchData()
      })
    },
    // 打开弹窗
    open(category, categoryValue, adjustreportid) {
      this.fetchProvincelist()
      console.log('111111111', adjustreportid)
      this.dialogTitle = this.categoryMap[category] || '更多数据'
      this.categoryType = category
      this.categoryValue = categoryValue
      this.adjustreportid = adjustreportid
      this.currentPage = 1
      this.pageSize = 10
      this.visible = true
    },

    // 获取数据
    fetchData() {
      this.loading = true

      // 构建请求参数
      const params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        recommend_type: this.categoryValue, // 0:保底,1:重点,2:备选,3:冲刺
        uid: this.queryParams.uid,
        adjust_report_id: this.adjustreportid,
        // 其他需要的参数...
      }

      // 调用接口
      getMoreData(params)
        .then((res) => {
          console.log('res', res)
          this.tableData = res.list || []
          if (res.list) {
            this.tableData = res.list.map((item) => {
              const matchedProvince = this.provincelist.find(
                (province) => province.code === item.college_province_code
              )
              return {
                ...item,
                province_name: matchedProvince ? matchedProvince.name : '',
              }
            })
          }
          this.total = res.count || 0
        })
        .catch((err) => {
          console.error('获取更多数据失败:', err)
          this.$message.error('获取数据失败')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 关闭弹窗
    handleClose() {
      this.visible = false
      this.$emit('close')
    },

    // 每页条数变化
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    },

    // 获取院校类型标签
    getCategoryLabel(value) {
      if (!value) return '未知类型'
      const found = this.$parent.category_ids?.find(
        (item) => item.value == value
      )
      return found ? found.label : '其他'
    },

    // 查看详情
    handleDetail(row) {
      this.$emit('detail', row)
      if (this.$parent.handleDetail) {
        this.$parent.handleDetail(row)
      }
    },
  },
}
</script>

<style scoped>
.loading-container {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.empty-data {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  font-size: 14px;
}

.el-dialog__wrapper /deep/ .el-dialog {
  border-radius: 8px;
}

.el-dialog__wrapper /deep/ .el-dialog__header {
  border-bottom: 1px solid #e8e8e8;
  padding: 15px 20px;
}

.el-dialog__wrapper /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.el-dialog__wrapper /deep/ .el-dialog__body {
  padding: 20px;
  max-height: 700px;
  overflow-y: auto;
}
</style>